import { render } from "./RegisterAdministration.vue?vue&type=template&id=65b4123d&scoped=true"
import script from "./RegisterAdministration.vue?vue&type=script&lang=js"
export * from "./RegisterAdministration.vue?vue&type=script&lang=js"

import "./RegisterAdministration.vue?vue&type=style&index=0&id=65b4123d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b4123d"]])

export default __exports__